import { IJaugeage } from '../../interfaces/models';
import { Action } from '@ngrx/store';

export const SET = '[Jaugeages] Set';
export const ADD = '[Jaugeages] Add';
export const EDIT = '[Jaugeages] Edit';
export const DELETE = '[Jaugeages] Delete';
export const OPEN_MODAL = '[Jaugeages] Open modal';
export const CLOSE_MODAL = '[Jaugeages] Close modal';

export class Set implements Action {
  readonly type = SET;

  constructor(public data: IJaugeage[]) {}
}

export class Add implements Action {
  readonly type = ADD;

  constructor(public data: IJaugeage) {}
}

export class Edit implements Action {
  readonly type = EDIT;

  constructor(public data: IJaugeage) {}
}

export class Delete implements Action {
  readonly type = DELETE;

  constructor(public id: any) {}
}

export class OpenModal implements Action {
  readonly type = OPEN_MODAL;
}

export class CloseModal implements Action {
  readonly type = CLOSE_MODAL;
}

export type All = Set | Add | Edit | Delete | OpenModal | CloseModal;
